import { render, staticRenderFns } from "./BackAboutRecruit.vue?vue&type=template&id=1637a920"
import script from "./BackAboutRecruit.vue?vue&type=script&lang=js"
export * from "./BackAboutRecruit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports